import react, {createContext} from 'react'
// save token and ID
export const authContext = createContext();

